import * as React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import {
  Heading,
  VStack,
} from '@ayble-health/dashboard-components';
import { Section } from './Section';
import { Tile } from './Tile';
import { brand, semanticColorTokens } from '../../theme/chakra';

const ColorBox = ({
  bg,
  colorPalette,
}: {
  bg: string;
  colorPalette?: string;
}) => (
  <Box
    bg={bg}
    colorPalette={colorPalette}
    h="56px"
    w="100%"
    rounded="md"
    borderWidth="1px"
    borderColor="cloud"
  />
);

const BrandColors = () => (
  <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 6 }} gap={4}>
    {Object.entries(brand).map(([name, hex]) => (
      <Tile key={name} label={name} note={hex}>
        <ColorBox bg={name} />
      </Tile>
    ))}
  </SimpleGrid>
);

const SemanticPalettes = () => (
  <VStack gap={6} align="stretch">
    {Object.entries(semanticColorTokens).map(([palette, slots]) => (
      <VStack key={palette} gap={2} align="stretch">
        <Heading size="sm" textTransform="capitalize">
          {palette}
        </Heading>
        <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 7 }} gap={4}>
          {Object.keys(slots).map((slot) => (
            <Tile key={slot} label={slot}>
              <ColorBox bg={`colorPalette.${slot}`} colorPalette={palette} />
            </Tile>
          ))}
        </SimpleGrid>
      </VStack>
    ))}
  </VStack>
);

export const ColorAudit = () => (
  <Section
    id="colors"
    title="Colors"
    description="Read live from src/theme/chakra.ts. Brand names are the canonical palette
      for new code; semantic palettes drive colorPalette= on Badge / Button /
      Alert. The legacy tier palettes still in use are in the Archive tab."
  >
    <VStack gap={8} align="stretch">
      <VStack gap={2} align="stretch">
        <Heading size="md">Brand colors</Heading>
        <BrandColors />
      </VStack>

      <VStack gap={2} align="stretch">
        <Heading size="md">Semantic palettes</Heading>
        <SemanticPalettes />
      </VStack>
    </VStack>
  </Section>
);
